
// eslint-disable-next-line import/prefer-default-export
export function preloadImg(...urls) {
  return urls.map((url) => {
    const img = new Image();
    img.src = url;
    return img;
  });
}
